import {
  ActivatedOfferItem,
  ActivatedTitledItem,
} from '@varo/graphql-schema-types';
import React, { createContext, ReactNode, useContext } from 'react';

interface MyOffersProviderProps {
  children: ReactNode;
  selfFundedItems: ActivatedTitledItem[];
  selfFundedSectionTitle: string | undefined;
  upsideOffers: ActivatedOfferItem[];
  upsideSectionTitle: string;
  upsideSectionSubtitle: string;
  inlineAlertBanner?: { title: string | null } | null;
  isOverlayLoading: boolean;
  isPageLoading: boolean;
  hasOverlayError: boolean;
  onOfferClick: (offer: ActivatedOfferItem) => void;
}

type MyOffersContextValue = Omit<MyOffersProviderProps, 'children'>;

const MyOffersContext = createContext<MyOffersContextValue | null>(null);

export const useMyOffersContext = (): MyOffersContextValue => {
  const context = useContext(MyOffersContext);
  if (!context) {
    throw new Error(
      'useMyOffersContext must be used within a MyOffersProvider',
    );
  }
  return context;
};

const MyOffersProvider = ({ children, ...value }: MyOffersProviderProps) => {
  const contextValue: MyOffersContextValue = {
    selfFundedItems: value.selfFundedItems,
    selfFundedSectionTitle: value.selfFundedSectionTitle,
    upsideOffers: value.upsideOffers,
    upsideSectionTitle: value.upsideSectionTitle,
    upsideSectionSubtitle: value.upsideSectionSubtitle,
    inlineAlertBanner: value.inlineAlertBanner,
    isOverlayLoading: value.isOverlayLoading,
    isPageLoading: value.isPageLoading,
    hasOverlayError: value.hasOverlayError,
    onOfferClick: value.onOfferClick,
  };

  return (
    <MyOffersContext.Provider value={contextValue}>
      {children}
    </MyOffersContext.Provider>
  );
};

export default MyOffersProvider;
